import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'GEMAR JAJAN',
    description: 'GEMAR JAJAN, toko keripik dan camilan renyah. Lihat kemasan 3D interaktif, pilih camilan favorit, lalu pesan mudah lewat WhatsApp.',
    placeholder: 'Teman Setia di Setiap Gigitan!',
    url: getOrigin(),
    ogImage: 'https://gemar-jajan.cdn.modulify.website/brand/gemar-jajan-logo.png'
}

export const LOGO_SRC = '/images/logo.png'
export const LOGO_WIDTH = 1024
export const LOGO_HEIGHT = 1536

export const CART_STORAGE_KEY = 'gemar-jajan-cart-v1'

export const SPECIAL_CATEGORY_SLUGS = {
    bestSeller: 'produk-terlaris',
    newest: 'produk-terbaru',
    bundle: 'paket-hemat'
} as const

export const ORDER_STATUSES = [
    { value: 'baru', label: 'Baru' },
    { value: 'diproses', label: 'Diproses' },
    { value: 'dikirim', label: 'Dikirim' },
    { value: 'selesai', label: 'Selesai' },
    { value: 'dibatalkan', label: 'Dibatalkan' }
] as const

export const LOW_STOCK_THRESHOLD = 10
